import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function MainMap() {
  const { t } = useTranslation();

  useEffect(() => {
    const disableContext = (e) => e.preventDefault();
    document.addEventListener('contextmenu', disableContext);
    return () => document.removeEventListener('contextmenu', disableContext);
  }, []);

  return (
    <section className="relative w-full text-center bg-white overflow-hidden">
      {/* Left Side Decorations */}
      <img
        src="/images/curly-arrow-decor.png"
        className="hidden sm:block absolute -left-0 top-[50%] opacity-60 w-[150px] rotate-90 pointer-events-none z-0"
        alt="decor"
      />

      {/* Right Side Decorations */}
      <img
        src="/images/Pin_Decor.png"
        className="hidden sm:block absolute right-20 top-[20%] w-30 opacity-60 rotate-12 pointer-events-none z-0"
        alt="decor"
      />
      <img
        src="/images/Shape decor.png"
        className="hidden sm:block absolute -right-0 top-[80%] opacity-60 w-[150px] rotate-90 pointer-events-none z-0"
        alt="decor"
      />

      {/* Content */}
      <div className="relative z-10">
        <div className="text-center mb-12">
          <p className="text-purple-800 text-lg font-bold mb-3 tracking-widest uppercase">
            {t('mainMap.subtitle')}
          </p>
          <h2 className="text-3xl md:text-5xl font-semibold text-gray-900">
            {t('mainMap.title')}
          </h2>
          <p className="mt-4 text-md text-gray-500 max-w-2xl mx-auto">
            {t('mainMap.description')}
          </p>
        </div>

        {/* Map Image */}
        <div className="mt-12 w-full max-w-7xl mx-auto">
          <img
            src="https://ik.imagekit.io/mediadata/Mo%20Ink%20n%20Dyes/MainMap.png?updatedAt=1746636596949"
            alt="India Connected Map"
            className="w-full h-auto object-contain pointer-events-none select-none"
            draggable={false}
          />
        </div>
      </div>
    </section>
  );
}
